import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getThemeSections } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import InpageSectionAccordion, { TitleWrapper } from './InpageSectionAccordion';
import { isEmbed } from 'ContentEditorUI/types/Section';
import InpageDraggableThemeSectionContainer from './InpageDraggableThemeSectionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
function InpageThemeSectionsContainerGrid({
  themeSections,
  onDragStart,
  onDragEnd,
  themePath,
  showTags
}) {
  return /*#__PURE__*/_jsx(CardGrid, {
    columns: 1,
    gutterSize: 10,
    marginBlockStart: "400",
    children: themeSections.map(section => {
      const key = isEmbed(section) ? `${section.id}-${section.name}` : `${section.id}-${section.label}`;
      return /*#__PURE__*/_jsx(InpageDraggableThemeSectionContainer, {
        section: section,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        themePath: themePath,
        showTags: showTags
      }, key);
    })
  });
}
export default function InpageThemeSectionsContainer({
  onDragStart,
  onDragEnd,
  themePath,
  showAccordion = true,
  showTags = true
}) {
  const themeSections = useSelector(getThemeSections);
  if (themeSections.length === 0) {
    return null;
  }
  if (showAccordion) {
    return /*#__PURE__*/_jsx(InpageSectionAccordion, {
      title: /*#__PURE__*/_jsx(TitleWrapper, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "addSectionPanel.customSections.themeSections",
          options: {
            count: themeSections.length
          }
        })
      }),
      type: PATAGONIA_ADD_PANEL_SUB_CATEGORIES.SECTIONS.THEME,
      children: /*#__PURE__*/_jsx(InpageThemeSectionsContainerGrid, {
        themeSections: themeSections,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        themePath: themePath,
        showTags: showTags
      })
    });
  } else {
    return /*#__PURE__*/_jsx(InpageThemeSectionsContainerGrid, {
      themeSections: themeSections,
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      themePath: themePath,
      showTags: showTags
    });
  }
}
InpageThemeSectionsContainer.propTypes = {
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired
};